module.exports = __webpack_public_path__ + "static/media/36.dae6b1c6.jpeg";